import { UseQueryResult, useQuery } from 'react-query'

import { fetchStatisticsData } from './services'
import { StatisticsType } from './types'

export function useStatisticsQuery(): UseQueryResult<StatisticsType> {
   return useQuery('userStats', fetchStatisticsData, { staleTime: 60 * (60 * 1000) })
}
